<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="openDialog()">Yeni Yönetici Ekle</v-btn>
      </v-col>
    </v-row>

    <!-- Yöneticiler Tablosu -->
    <v-data-table :headers="headers" :items="yoneticiler" item-key="yoneticiId" class="elevation-1">
      <template v-slot:item.aktif="{ item }">
        <v-chip :color="item.aktif ? 'green' : 'red'" dark>
          {{ item.aktif ? 'Aktif' : 'Pasif' }}
        </v-chip>
      </template>
      <template v-slot:item.yoneticiType="{ item }">

        {{ yoneticiTips[item.yoneticiType].name }}

      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="editYonetici(item)">
          <v-icon color="blue">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deleteYonetici(item)">
          <v-icon color="red">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Dialog Form -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedIndex === -1 ? 'Yeni Yönetici' : 'Yönetici Düzenle' }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-text-field v-model="editedItem.tc" label="TC" required></v-text-field>
            <v-text-field v-model="editedItem.ad" label="Ad" required></v-text-field>
            <v-text-field v-model="editedItem.soyad" label="Soyad" required></v-text-field>
            <v-text-field v-model="editedItem.posta" label="E-posta" required></v-text-field>
            <v-select v-model="editedItem.yoneticiType" :items="yoneticiTips" item-text="name" item-value="id"
              label="Yönetici Tipi"></v-select>
            <v-switch v-model="editedItem.aktif" label="Aktif mi?"></v-switch>
   
            <v-combobox v-model="selectedBirim" :items="birims" :return-object="true" item-text="ad"
              item-value="id" value="id" label="Birim"></v-combobox>
            <!-- <v-text-field v-model="editedItem.birimId" label="Birim Id"></v-text-field> -->
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">İptal</v-btn>
          <v-btn color="primary" text @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BirimService from '@/services/BirimService';
import YoneticiService from '@/services/YoneticiService';
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue';
export default {
  name: 'YoneticiYonetimi',
  data: () => ({
    dialog: false,
    selectedBirim: null,
    headers: [
      { text: 'TC', value: 'tc' },
      { text: 'Ad', value: 'ad' },
      { text: 'Soyad', value: 'soyad' },
      { text: 'E-posta', value: 'posta' },
      { text: 'Tip', value: 'yoneticiType' },
      { text: 'Durum', value: 'aktif' },
      { text: 'Birim', value: 'birimName' },
      { text: 'İşlemler', value: 'actions', sortable: false }
    ],
    yoneticiler: [],
    yoneticiTips: [
      { id: 0, name: 'Kullanıcı' },
      { id: 1, name: 'Admin' },
      { id: 2, name: 'Anket Admin' }],
    editedIndex: -1,
    birims: [],
    editedItem: {
      yoneticiId: '',
      tc: '',
      ad: '',
      soyad: '',
      posta: '',
      yoneticiType: 2,
      aktif: true,
      birimId: null,
      birimName: ''
    }
  }),
  created() {
    this.databind();
  },
  watch: {
  selectedBirim(newVal) {
    if (newVal) {
      this.editedItem.birimId = newVal.id;     // backend için id
     // this.editedItem.birimName = newVal.name; // UI veya log için name
    } else {
      this.editedItem.birimId = null;
      //this.editedItem.birimName = '';
    }
  }
},

  methods: {
    databind() {
      YoneticiService.listYoneticiler().then((result) => {
        this.yoneticiler = result.data;
        console.log(this.yoneticiler);
      }).catch((err) => {

      });
      BirimService.listBirims().then((result) => {
        this.birims = result.data;
        console.log("Birims:", this.birims);
      }).catch((err) => {

      });
    },
    openDialog() {
      this.editedIndex = -1;
      this.editedItem = {
        yoneticiId: '',
        tc: '',
        ad: '',
        soyad: '',
        posta: '',
        yoneticiType: 2,
        aktif: true,
        birimId: null
      };
      this.dialog = true;
    },
    editYonetici(item) {
      this.editedIndex = this.yoneticiler.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.selectedBirim = this.birims.find(b => b.id === item.birimId);
      this.dialog = true;
    },
    deleteYonetici(item) {
      const index = this.yoneticiler.indexOf(item);

      var cevap= confirm('Silmek istediğinize emin misiniz?');
      if (cevap) {
        YoneticiService.delete(item.yoneticiId).then((result) => {
          this.yoneticiler.splice(index, 1);
          this.$toast.success('Yönetici silindi.');
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    save() {
      if (this.editedIndex > -1) {
        YoneticiService.update(this.editedItem.yoneticiId, this.editedItem).then((result) => {
          console.log(result);
          Vue.set(this.yoneticiler, this.editedIndex, result.data);
                    this.$toast.success('Yönetici Güncellendi.');
          //this.yoneticiler[this.editedIndex] = result.data;
        }).catch((err) => {
          console.log(err);
        });
        //  Object.assign(this.yoneticiler[this.editedIndex], this.editedItem);
      } else {
        // this.editedItem.yoneticiId = uuidv4();
        console.log("YeniKayıt:", this.editedItem);
        YoneticiService.insert(this.editedItem).then((result) => {
          this.yoneticiler.push(result.data);
                    this.$toast.success('Yönetici Eklendi.');
         // console.log(result);
        }).catch((err) => {
          console.log(err);
        });

      }
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>